import React from 'react';
import { formatCurrency } from 'utils/functions';

export type VendorStatsType = {
  title: string;
  value: string;
};

const VendorStats = ({ list }: { list: VendorStatsType[] }) => {
  return (
    <div className='bg-[#F7F7F8] w-full h-auto p-1 flex  justify-center items-center rounded-md   '>
      <div className='bg-white w-full h-auto rounded-md py-6'>
        <div className='px-2 w-full md:w-[85%] mx-auto items-center md:h-[120px] flex justify-between md:justify-around'>
          {list?.map((item, index) => (
            <div
              key={index}
              className={`font-medium tracking-widest text-center  h-fit w-[33%] mr-2 ${
                index !== list?.length - 1 ? 'border-r border-gray-13' : ''
              }`}>
              <label className='text-2xs text-gray-9 uppercase'>{item?.title}</label>
              <h4 className='text-base md:text-2xl text-[#2E3031] font-medium '>
                NGN{' '}
                {formatCurrency(item?.value, {
                  style: 'decimal'
                })}
              </h4>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default VendorStats;
